// extracted by mini-css-extract-plugin
module.exports = {"text":"Radio_text__3AT1W","radioContainer":"Radio_radioContainer__2kVTo","insetText":"Radio_insetText__1NnjK","radio":"Radio_radio__22-wM"};